import type { ProvinceDTO } from "../../../api/contract";
import {
  ADE_DEFAULT_JOB_RATE_REQ_PER_MIN,
  ADE_ESTIMATE_YEARS_FULL,
  ADE_REQS_PER_ZONE_YEAR,
} from "../../../api/scrape-config";
import type { GeocodeHit } from "../../api";

export interface LookupEstimate {
  secSingle: number;
  secZone10y: number;
  minComune: number;
  hoursProvince: number;
  reqsProvince: number;
  zonesPerComune: number;
}

export function getProvinceForHit(
  selected: GeocodeHit | null,
  provinces: ProvinceDTO[],
): ProvinceDTO | null {
  const provinceCode = selected?.address?.provinceCode;
  if (!provinceCode) return null;
  return provinces.find((province) => province.code === provinceCode) || null;
}

export function buildScrapeEstimate(province: ProvinceDTO): LookupEstimate {
  const zonesPerComune = province.estOMI / Math.max(1, province.comuni);
  const secSingle = 0.5;
  const secZone10y =
    (ADE_ESTIMATE_YEARS_FULL * ADE_REQS_PER_ZONE_YEAR) /
    (ADE_DEFAULT_JOB_RATE_REQ_PER_MIN / 60);
  const minComune =
    (zonesPerComune * ADE_ESTIMATE_YEARS_FULL * ADE_REQS_PER_ZONE_YEAR) /
    ADE_DEFAULT_JOB_RATE_REQ_PER_MIN;
  const hoursProvince =
    (province.estOMI * ADE_ESTIMATE_YEARS_FULL * ADE_REQS_PER_ZONE_YEAR) /
    ADE_DEFAULT_JOB_RATE_REQ_PER_MIN /
    60;

  return {
    secSingle,
    secZone10y,
    minComune,
    hoursProvince,
    reqsProvince: province.estOMI * ADE_ESTIMATE_YEARS_FULL * ADE_REQS_PER_ZONE_YEAR,
    zonesPerComune,
  };
}
